import { APP_INITIALIZER } from '@angular/core';

import { AppConfigService } from './app-config.service';


const appConfigFactory = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

export const AppConfigProvider = {
  provide: APP_INITIALIZER,
  useFactory: appConfigFactory,
  multi: true,
  deps: [AppConfigService]
};
